<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>





<!-- Navigation -->
<fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader class="w-full">
        <!-- Logo -->
        <div class="flex justify-center items-center h-20 p-6 pb-0">
            <!-- Light version -->
            <img
                class="dark:hidden w-12"
                [src]="logo"
                alt="Logo image">
            <!-- Dark version -->
            <img
                class="hidden dark:flex w-12"
                [src]="logoBlack"
                alt="Logo image">

                <!-- <a href="#/home" class="w-full px-3 py-2 mt-4 -mb-2 hover:bg-slate-700 rounded-lg">
                    <div class="flex flex-row w-full">
                        <mat-icon [svgIcon]="'heroicons_solid:home'"></mat-icon>
                        <div class="mt-0.5 pl-4">
                            <span>Inicio</span>
                        </div>
                    </div>
                </a> -->


                <a href="#/home" class="w-full px-3 py-2  rounded-lg">
                    <div class="flex flex-row mx-4 w-full">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e8eaed"><path d="M300-80q-59 0-99.5-40.5T160-220v-520q0-58 40.5-99t99.5-41h500v600q-26 0-43 17.5T740-220q0 26 17 43t43 17v80H300Zm0-80h373q-6-14-9.5-28.5T660-220q0-16 3-31t10-29H300q-26 0-43 17.5T240-220q0 26 17 43t43 17Zm-60-187q14-7 28.5-10t31.5-3h420v-440H300q-26 0-43 17.5T240-740v393Zm109-93h49l25-71h113l25 71h49L504-720h-50L349-440Zm88-112 41-116h3l41 116h-85ZM240-347v-453 453Z"/></svg>

                        <div class="mt-0.5 pl-4">
                            <span>Manuales</span>
                        </div>
                    </div>
                </a>
        </div>

    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <!-- Navigation toggle button -->
        <button
            mat-icon-button
            (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
        </button>
        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
            <!-- <languages></languages> -->
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <search [appearance]="'bar'"></search>
            <shortcuts></shortcuts>
            <!-- <messages></messages> -->
            <!-- <notifications></notifications> -->
            <button
                class="lg:hidden"
                mat-icon-button
                > <!-- (click)="quickChat.toggle()"> -->

                <mat-icon [svgIcon]="'heroicons_outline:chat-alt-2'"></mat-icon>
            </button>
            <user></user>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true">
            
        </router-outlet>
    </div>

    <!-- Footer -->
    <!--<div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">Fuse &copy; {{currentYear}}</span>
    </div>-->

</div>

<!-- Quick chat -->
<!-- <quick-chat #quickChat="quickChat"></quick-chat> -->
